export default __webpack_public_path__ + "static/media/img6.f259c374.jpg";